<template>
  <div>
    <div class="w-100 d-inline-block bg-book-banner-image">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <h1 class="text-black fw-bold text-full-24 family-grand-stander margin-bottom-2 margin-top-2 text-size-24" data-bs-toggle="modal" data-bs-target="#AddressDetailModal">
                Blog
              </h1>
              <p class="text-full-12 text-size-12 text-black family-inter-light mb-0">
                <img class="calendar-icon" src="@/assets/images/blog-clock.svg" alt="picture">    
                Last Updated On {{ formatDateDay(blog.published_at) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row margin-top-3 margin-bottom-3">
        <div class="col-xl-9 col-12 col-sm-8 col-md-8 
          col-lg-8">
          <div class="w-100 d-inline-block bg-introduction padding-3 rounded-4 padding-bottom-2">
            <div class="row">
              <div class="col-12 margin-bottom-2">
                <div class="w-100 d-inline-block blog-card padding-3 bg-white rounded-4 blog-detail-card">
                  <div class="card w-100 d-inline-block position-relative border-0">
                      <img class="w-100 rounded-3" 
                          v-lazy="$getImageUrl(blog.featured_image)" 
                          alt="picture" 
                        />
                    <a class="text-white text-size-12 text-full-12 blog-theme-badge position-absolute rounded-3 family-inter-bold fw-bold pets-btn-3" href="javascript:void(0)">
                    {{ blog.category?.name }}
                    </a>
                  </div>
                  <div class="w-100 d-inline-block margin-top-3">
                    <h1 class="card-title text-full-20 text-size-20 text-black family-inter-light fw-bold mb-0">
                      {{ blog.title }}
                    </h1>
                  </div>
                  <div class="w-100 d-inline-block margin-top-1 margin-bottom-1">
                    <a href="javascript:void(0)" class="nav-color text-full-12 text-size-12 me-2">
                    <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                    {{ formatDate(blog.published_at) }}
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <i aria-hidden="true" class="fa fa-facebook"></i>
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <img class="calendar-icon" src="@/assets/images/x-icon.svg" alt="picture">
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="w-100 d-inline-block blog-detail-introduction">
                    <div v-if="blogContentSplit.useMiddle" v-html="blogContentSplit.before"></div>
                    <div v-else-if="blog && blog.content" v-html="blog.content"></div>

                    <div
                      v-if="blog && blog.category && planDetailPrices.length"
                      class="blog-inline-services blog-services-section w-100 d-inline-block bg-plans rounded-4 padding-3 margin-top-3"
                    >
                      <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
                        <div class="blog-services-carousel-wrap carousel-container">
                          <transition-group class="carousel d-flex blog-services-carousel" style="gap: 20px;" tag="div">
                            <div v-for="(plan) in planDetailPrices" :key="plan.id" class="slide blog-service-slide">
                              <div class="card w-100 h-100 d-flex flex-column border-0 rounded-4 plan-card plan-card--blog shadow-sm">
                                <img class="slide-image w-100 flex-shrink-0" v-lazy="$getImageUrl(plan.image)" :alt="plan.name" style="height: 168px; object-fit: cover;">
                                <div class="card-body d-flex flex-column blog-plan-card-body">
                                  <h3 class="card-title text-size-16 filson-black-family fw-bold mb-1 text-black plan-card__title">
                                    {{ plan.name }}
                                  </h3>
                                  <p class="card-text text-muted text-size-14 family-inter-light mb-0 text-lh-large plan-card__desc">
                                    {{ plan.description }}
                                  </p>
                                  <div class="plan-card-actions d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    <a href="javascript:void(0)" class="btn btn-blog-cta text-uppercase text-size-12 fw-bold px-3 py-2 flex-shrink-0"
                                      @click="addToCart(plan)">
                                      BOOK SERVICE
                                    </a>
                                    <span class="text-size-18 fw-bold filson-black-family price-text flex-shrink-0">
                                      {{ plan.unit }}{{ plan.price }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </transition-group>
                          <div class="carousel-dots blog-services-dots w-100 d-flex justify-content-center">
                            <span class="dot mx-1" @click="previous()"></span>
                            <span class="dot mx-1 active"></span>
                            <span class="dot mx-1" @click="next()"></span>
                            <span class="dot mx-1" @click="next()"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="blogContentSplit.useMiddle && blogContentSplit.after" v-html="blogContentSplit.after"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-12 col-sm-4 col-md-4 
          col-lg-4 mt-xl-0 mt-3 mt-md-0">
          <div class="w-100 d-inline-block bg-green bg-recent-post margin-top-2">
            <p class="text-white text-size-13 family-inter-light text-full-13 fw-bold mb-0 padding-top-2 padding-bottom-2 padding-left-3 padding-right-3">Recent Post</p>
          </div>
          <div class="w-100 d-inline-block bg-introduction padding-3 padding-top-2 recent-service-bg">
            <div v-for="latestBlog in latestBlogs" :key="latestBlog.id" class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4 margin-top-2">
              <div class="card w-100 d-inline-block position-relative border-0">
                <!-- <img class="w-100 rounded-3" src="@/assets/images/blog-image-9.png" alt="picture"> -->
                 <img class="w-100 rounded-3" 
                    v-lazy="$getImageUrl(latestBlog.featured_image)" 
                    alt="picture" 
                  />
                <a class="text-white text-size-12 text-full-12 blog-theme-badge position-absolute rounded-3 family-inter-bold fw-bold pets-btn-2" href="javascript:void(0)">
                {{ latestBlog.category?.name }}
                </a>
                <div class="card-body padding-2 pb-0">
                  <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">
                    {{ latestBlog.title }}
                  </h5>
                  <a href="javascript:void(0)" class="nav-color text-full-12 text-size-12">
                  <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                   {{ formatDate(latestBlog.published_at) }}
                  </a>
                  <p class="card-text text-full-12 text-size-12 text-black family-inter-light mb-0">
                    {{ stripHtml(latestBlog.content).slice(0, 200) }}...
                  </p>
                  <a href="javascript:void(0)" class="btn blog-theme-btn margin-top-2 text-size-12 text-full-12 px-3 py-1 rounded-2">
                    See More
                  </a>
                  <router-link :to="`/blog/${latestBlog.slug}`" class="circle-anchor position-absolute">
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4 margin-top-3">
              <div class="card w-100 d-inline-block position-relative border-0">
                <img class="w-100 rounded-3" src="@/assets/images/blog-image-10.png" alt="picture">
                <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn-2" href="javascript:void(0)">
                Dog, Pets
                </a>
                <div class="card-body padding-2 pb-0">
                  <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">How Do Dogs Get Heartworms?</h5>
                  <a href="javascript:void(0)" class="text-green text-full-12 text-size-12">
                  <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                  20 March, 2024
                  </a>
                  <p class="card-text text-full-12 text-size-12 text-black family-inter-light">Our four-legged companions hold a special place in our hearts, providing unconditional love and companionship. However, like humans, dogs are susceptible to various health concerns</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
      bg-orange">
      <div class="container autoContent">
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home nav-color" aria-hidden="true"></i>
                Home  /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'blogDetailBannerComponent',
    data() {
      return {
        blog: null,
        latestBlogs: [],
        planDetailPrices: [],
      };
    },
    mounted() {
      this.getSingleBlog();
    },
    computed: {
      blogContentSplit() {
        const html = (this.blog && this.blog.content) ? this.blog.content : '';
        if (!html) {
          return { before: '', after: '', useMiddle: false };
        }
        const re = /<\/p>/gi;
        const endIndices = [];
        let match;
        while ((match = re.exec(html)) !== null) {
          endIndices.push(match.index + match[0].length);
        }
        if (endIndices.length >= 2) {
          const paraIdx = Math.ceil(endIndices.length / 2) - 1;
          const splitPos = endIndices[Math.max(0, Math.min(endIndices.length - 1, paraIdx))];
          const before = html.slice(0, splitPos);
          const after = html.slice(splitPos).trim();
          if (after.length) {
            return { before, after, useMiddle: true };
          }
        }
        return { before: html, after: '', useMiddle: false };
      },
    },
   watch: {
    '$route.params.slug': function () {
      this.getSingleBlog();
    }
  },
  methods: {
    async getSingleBlog() {
      try {
        const slug = this.$route.params.slug;
        const response = await this.$axios.post('/get-blog-detail', {
          website_name: this.activeWebsiteName,  // Include website name in the request body
          slug: slug,  // Include website name in the request body
        });
      if (response.data.status === "success") {
        this.blog = response.data.blog;
        this.latestBlogs = response.data.latest_blogs || [];
        this.planDetailPrices = [];
        await this.fetchServicesForBlogCategory();
      // console.log("Blog detail fetched successfully:", this.blog);
      } else {
        console.error("Failed to fetch blogs:", response.data);
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
    }
    },
     stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
     formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }).format(date);
    },
    formatDateDay(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }).format(date);
    },
    alternateServiceCategoryName(categoryName) {
      if (!categoryName || typeof categoryName !== 'string') {
        return null;
      }
      const trimmed = categoryName.trim();
      const map = {
        Dog: 'Dog Grooming',
        Dogs: 'Dog Grooming',
        Cat: 'Cat Grooming',
        Cats: 'Cat Grooming',
        Bird: 'Birds Grooming',
        Birds: 'Birds Grooming',
        Rabbit: 'Rabbit Grooming',
        Rabbits: 'Rabbit Grooming',
      };
      if (map[trimmed]) {
        return map[trimmed];
      }
      if (!/grooming/i.test(trimmed)) {
        return `${trimmed} Grooming`;
      }
      return null;
    },
    /**
     * Full category list: booking catalog (/get-categories) + carousel/custom list (/get-service-categories), merged by id.
     */
    async fetchServicesForBlogCategory() {
      if (!this.blog?.category) {
        return;
      }

      const [fromCatalog, fromServiceCategories] = await Promise.all([
        this.fetchAllPlanPricesForBlogCategory(),
        this.fetchPlanPricesFromServiceCategoriesList(),
      ]);

      this.planDetailPrices = this.mergePlanPriceListsOrdered(fromCatalog, fromServiceCategories);
    },
    mergePlanPriceListsOrdered(catalogItems, customItems) {
      const seen = new Set();
      const out = [];
      const append = (item) => {
        if (!item || item.id == null) {
          return;
        }
        const key = String(item.id);
        if (seen.has(key)) {
          return;
        }
        seen.add(key);
        const norm = this.normalizePlanDetailPriceForCarousel(item);
        if (norm) {
          out.push(norm);
        }
      };
      (catalogItems || []).forEach(append);
      (customItems || []).forEach(append);
      return out;
    },
    resolveServiceCategoryId(categories) {
      if (!Array.isArray(categories) || !this.blog?.category) {
        return null;
      }
      const blogCat = this.blog.category;
      if (blogCat.id != null) {
        const byId = categories.find((c) => String(c.id) === String(blogCat.id));
        if (byId) {
          return byId.id;
        }
      }
      if (blogCat.name) {
        const n = blogCat.name.trim().toLowerCase();
        const byName = categories.find((c) => c.name && c.name.trim().toLowerCase() === n);
        if (byName) {
          return byName.id;
        }
        const alt = this.alternateServiceCategoryName(blogCat.name);
        if (alt) {
          const a = alt.trim().toLowerCase();
          const byAlt = categories.find((c) => c.name && c.name.trim().toLowerCase() === a);
          if (byAlt) {
            return byAlt.id;
          }
        }
      }
      return null;
    },
    normalizePlanDetailPriceForCarousel(p) {
      if (!p || p.id == null) {
        return null;
      }
      const priceVal = p.price != null && p.price !== '' ? p.price : p.sale_price;
      const unit = p.unit != null && String(p.unit).trim() !== '' ? p.unit : 'AED ';
      return {
        ...p,
        name: p.name,
        description: p.description || '',
        image: p.image,
        unit,
        price: priceVal,
      };
    },
    async fetchAllPlanPricesForBlogCategory() {
      try {
        const response = await this.$axios.post('/get-categories', {
          website_name: this.activeWebsiteName,
        });
        if (response.data.status !== 'success' || !Array.isArray(response.data.planDetails)) {
          return [];
        }
        const categoryId = this.resolveServiceCategoryId(response.data.categories || []);
        if (categoryId == null) {
          return [];
        }
        const rows = response.data.planDetails.filter(
          (item) => String(item.category_id) === String(categoryId),
        );
        const flat = [];
        const seen = new Set();
        rows.forEach((row) => {
          const prices = row.plan_detail_prices || [];
          prices.forEach((p) => {
            const norm = this.normalizePlanDetailPriceForCarousel(p);
            if (norm && !seen.has(norm.id)) {
              seen.add(norm.id);
              flat.push(norm);
            }
          });
        });
        return flat;
      } catch (error) {
        console.error('Error loading services from get-categories:', error.response || error.message);
        return [];
      }
    },
    /** All planDetailPrices from /get-service-categories for every name variant (custom + featured lists). */
    async fetchPlanPricesFromServiceCategoriesList() {
      const raw = this.blog?.category?.name?.trim();
      if (!raw) {
        return [];
      }
      const candidates = [...new Set([raw, this.alternateServiceCategoryName(raw)].filter(Boolean))];
      const merged = [];
      const seen = new Set();
      for (const category_name of candidates) {
        try {
          const response = await this.$axios.post('/get-service-categories', {
            website_name: this.activeWebsiteName,
            category_name,
          });
          if (response.data.status === 'success' && Array.isArray(response.data.planDetailPrices)) {
            response.data.planDetailPrices.forEach((p) => {
              if (p && p.id != null && !seen.has(String(p.id))) {
                seen.add(String(p.id));
                merged.push(p);
              }
            });
          }
        } catch (error) {
          console.error('Error fetching get-service-categories:', error.response || error.message);
        }
      }
      return merged;
    },
    addToCart(service) {
      const cartData = localStorage.getItem('cart');
      let cart = cartData ? JSON.parse(cartData) : [];

      const serviceExists = cart.find((item) => item.id === service.id);

      if (serviceExists) {
        serviceExists.count++;
      } else {
        cart.push({ ...service, count: 1 });
      }
      localStorage.setItem('cart', JSON.stringify(cart));
      this.$router.push('/booking/');
    },
    previous() {
      const last = this.planDetailPrices.pop();
      this.planDetailPrices = [last].concat(this.planDetailPrices);
    },
    next() {
      const first = this.planDetailPrices.shift();
      this.planDetailPrices = this.planDetailPrices.concat(first);
    },
  }
  }
</script>
<style scoped>
.text-lh-large {
  line-height: 1.8;
}
.blog-services-section {
  padding-bottom: 0.75rem !important;
  margin-bottom: 0.25rem !important;
}
.blog-inline-services .gallery-slider .blog-services-carousel-wrap {
  margin-bottom: 0;
  padding-bottom: 0;
  min-height: 0;
}
.blog-inline-services .blog-services-dots {
  margin-top: 0.5rem;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
/* Desktop/tablet: min block height matches design; mobile stays auto */
@media (min-width: 992px) {
  .blog-inline-services .blog-services-carousel-wrap {
    display: flex;
    flex-direction: column;
    min-height: 465px;
  }
  .blog-inline-services .blog-services-carousel-wrap .blog-services-carousel {
    flex: 1 1 auto;
    align-items: stretch;
    min-height: 0;
  }
}
.blog-inline-services .gallery-slider .blog-services-carousel {
  align-items: flex-start;
  justify-content: flex-start;
}
.blog-inline-services .gallery-slider .blog-service-slide {
  flex: 0 0 calc((100% - 40px) / 3);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;
  min-width: 0;
  padding: 0;
}
@media (min-width: 992px) {
  .blog-inline-services .gallery-slider .blog-service-slide {
    align-items: stretch;
    align-self: stretch;
  }
}
.blog-inline-services .plan-card--blog {
  overflow: hidden;
  background-color: #fff;
  min-width: 0;
}
@media (min-width: 992px) {
  .blog-inline-services .plan-card--blog {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.blog-inline-services .about-slider .slide .card-body.blog-plan-card-body {
  flex: 0 0 auto;
  padding: 0.875rem 1rem 0.625rem 1rem !important;
}
@media (min-width: 992px) {
  .blog-inline-services .about-slider .slide .card-body.blog-plan-card-body {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.blog-inline-services .about-slider .plan-card--blog .plan-card__title.card-title,
.blog-inline-services .about-slider .plan-card--blog h3.plan-card__title {
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
}
.blog-inline-services .about-slider .plan-card--blog .plan-card__desc.card-text,
.blog-inline-services .about-slider .plan-card--blog p.plan-card__desc {
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
}
.blog-inline-services .plan-card__title {
  flex-shrink: 0;
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}
.blog-inline-services .plan-card__desc {
  flex: 0 0 auto;
  overflow-wrap: anywhere;
  word-break: break-word;
}
@media (min-width: 992px) {
  .blog-inline-services .plan-card__desc {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.blog-inline-services .plan-card-actions {
  flex-shrink: 0;
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}
@media (min-width: 992px) {
  .blog-inline-services .plan-card-actions {
    margin-top: auto;
    padding-top: 0.5rem;
  }
}
.plan-card {
  transition: all 0.3s ease;
}
.blog-inline-services .btn-blog-cta {
  transition: all 0.3s ease;
  border: 2px solid #F8721F !important;
  color: #F8721F !important;
  background-color: transparent !important;
}
.price-text {
  transition: all 0.3s ease;
  color: #000;
}
.blog-inline-services .plan-card--blog:hover .btn-blog-cta {
  background-color: #F8721F !important;
  border-color: #F8721F !important;
  color: #fff !important;
}
.blog-inline-services .plan-card--blog:hover .price-text {
  color: #F8721F;
}
.dot {
  width: 8px;
  height: 8px;
  background-color: #ddd;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dot.active, .dot:hover {
  background-color: #F8721F;
}
@media (max-width: 991.98px) {
  .blog-inline-services .gallery-slider .blog-service-slide {
    flex: 0 0 calc(100% - 20px) !important;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .blog-inline-services .gallery-slider .blog-service-slide {
    flex: 0 0 calc((100% - 20px) / 2) !important;
  }
}
</style>